module.exports = __webpack_public_path__ + "img/members.57589c02.svg";